import React, { FC, useState } from 'react'
import Styles from "../styles/VideoThumbnail.module.scss"
import { changeMillisec2Minute } from '../utils/utilFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import clsx from "clsx"

type Props = {
    file: string
    thumbnail: string
    videoDuration: number
    isSelected: boolean
    onClick: () => void
}

export const VideoThumbnail: FC<Props> = ( { thumbnail, file, videoDuration, isSelected, onClick } ) => {

    return (
        <div className={ Styles.container }>
            <div className={ Styles.thumbnail_container }>
                <div className={ clsx( Styles.thumbnail_wrapper, isSelected && Styles.selected_video_thumbnail ) }
                    onClick={ onClick } >
                    <img
                        className={ Styles.thumbnail }
                        src={ thumbnail } />
                    { videoDuration &&
                        <div className={ Styles.video_thumbnail_duration }>
                            { changeMillisec2Minute( videoDuration ) }
                        </div> }
                    <FontAwesomeIcon
                        className={ Styles.video_play_button_on_thumbnail }
                        icon={ faPlayCircle as IconProp } />
                </div>
            </div>
        </div> )
}
